import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FinalCTA() {
  return <section className="bg-arena flex flex-col items-center justify-center text-center px-6 md:px-20 pt-[64px] md:pt-[80px] pb-[64px] md:pb-[80px]" data-id="element-183">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center max-w-[720px]" data-id="element-184">
        <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-[0.15em] mb-8" data-id="element-185">
          ¿LISTO PARA SABERLO?
        </span>

        <h2 className="font-display text-[48px] md:text-[64px] font-bold text-carbon leading-[1.1] tracking-tightest mb-12 max-w-[720px]" data-id="element-186">
          Tu próximo cliente ya está buscando.
          <br data-id="element-187" />
          ¿Qué encuentra cuando llega a tu sitio?
        </h2>

        <Link to="/diagnostico" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[15px] md:text-[16px] px-[36px] py-[16px] rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-188">
          Diagnosticar mi sitio web <ArrowRight size={18} className="ml-2" data-id="element-189" />
        </Link>

        <p className="font-body text-[13px] text-carbon/35 mt-4" data-id="element-190">
          Diagnóstico de tu sitio web · Sin costo · 48 horas · Sin compromiso
        </p>

        <div className="mt-20 flex flex-col items-center" data-id="element-191">
          <div className="w-[60px] h-px bg-carbon/15 mb-4" data-id="element-192"></div>
          <span className="font-body text-[12px] text-carbon/30" data-id="element-193">
            Origen Studio · Colombia · 2025
          </span>
        </div>
      </motion.div>
    </section>;
}